import React from 'react';
import './CompanyIntro.css';

function CompanyIntro() {
  return (
    <section className="company-intro">
      <div className="intro-container">
        <div className="intro-left">
          <h2>Welcome to <span className="highlight">Klyzen Ventures LLP</span></h2>
          <p>
            Klyzen Ventures is a future-forward, multi-industry enterprise headquartered in India — driving transformation across 25+ sectors. From Technology and Education to Manufacturing, Healthcare, Retail, and Future Tech, we build what tomorrow needs today.
          </p>
          <p>
            By connecting traditional industries with cutting-edge innovation, we deliver scalable impact, sustainable growth, and digital excellence. Our ecosystem empowers startups, enterprises, communities, and talent to thrive in a connected world.
          </p>
          <p>
            At Klyzen, we believe in one vision: <strong>Innovation. Integrity. Impact.</strong>
          </p>
        </div>

        <div className="intro-right">
          <img
          src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d"
          alt="Klyzen Ventures"
          className="intro-image"
        />


        </div>
      </div>
    </section>
  );
}

export default CompanyIntro;
